var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[ 'wrapper', { hideNav: _vm.hideNav, clean: _vm.clean } ]},[_c('BreakdownDialog'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('CookieLaw')],1)}
var staticRenderFns = []

export { render, staticRenderFns }